import { useContext } from "react";
import ModulePanel from "./ModulePanel";
import BrandAuditV2DetailPane from "./BrandAuditV2DetailPane";
import { AuthContext } from "../../../context/auth-context";
import { resolveOpenTransactionId } from "../api/homePageApi";
import { ENTITY_LABELS } from "../../../utils/labelMapping";
import { isFlagOn } from "../../../utils/navFlags";

const MODULE_KEY = "brandAudit";
// Getter: resolved at render time so per-customer label overrides apply
// V2: just "Assessment" (V1 says "Brand Assessment") since the list now also holds Category runs
const getModuleLabel = () => ENTITY_LABELS.audit;

/**
 * V2 of BrandAuditModule (BrandAuditModule.js, left untouched).
 *
 * DIFFERENT FROM V1
 *  - Data comes from getHomePageDataV2 (apiVersion 2): Brand/Product Assessment
 *    runs plus Category Analysis runs in one list. Category runs are only
 *    requested when isFlagOn(is_categoryanalysis_enabled) - see utils/navFlags.js.
 *  - Cards pick brand vs category layout per record (RecordCard, recordKind).
 *  - Detail pane picks per record (BrandAuditV2DetailPane).
 *  - "View full" deep link goes to /category-analysis for Category records.
 *
 * TO REVERT: in moduleRegistry.js map `brandAudit` back to BrandAuditModule and
 * re-enable the Category Analysis tab in HomePageNew.js.
 */
function buildFullViewUrl(record, { userId, customerId }) {
  if (!record?.transactionId || !userId) return null;
  if (record.recordKind === "categoryAnalysis") {
    // Same deep link as CategoryAnalysisModule ("type" is only a truthiness gate there)
    const params = new URLSearchParams({
      type: "brand",
      id: resolveOpenTransactionId(record),
      user_id: userId,
      customer_id: customerId,
    });
    return `/luminaire/category-analysis?${params.toString()}`;
  }
  const params = new URLSearchParams({
    type: (record.type || "brand").toLowerCase(),
    id: resolveOpenTransactionId(record),
    user_id: userId,
    customer_id: customerId,
  });
  return `/luminaire/brand-audit?${params.toString()}`;
}

export default function BrandAuditV2Module() {
  const { user } = useContext(AuthContext);
  return (
    <ModulePanel
      moduleKey={MODULE_KEY}
      moduleLabel={getModuleLabel()}
      weightTag="multi-combination · point-in-time"
      DetailPane={BrandAuditV2DetailPane}
      buildFullViewUrl={buildFullViewUrl}
      apiVersion={2}
      includeCategory={isFlagOn(user?.is_categoryanalysis_enabled)}
    />
  );
}
